<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      sm="2">
      <label class="mt-1">แหล่งที่มา:</label>
    </v-col>
    <v-col
      cols="12"
      sm="10">
      <v-row no-gutters>
        <v-col
          cols="12"
          sm="3"
          v-for="(color, name) in promotionTypes"
          :key="name"
           class="my-3 my-md-1">
          <v-checkbox
            v-model="types"
            :label="name"
            :color="color"
            :value="name"
            hide-details
            class="mt-1"/>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      types: [],
    }
  },
  props: {
    value: { types: Number, require: true },
  },
  mounted() {
    this.types = this.value
  },
  watch: {
    types (newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) this.$emit('input', newVal)
    },
    value (newVal) {
      this.types = newVal
    },
  },
  computed: {
    ...mapGetters({
      promotionTypes: 'Calendar/getTypes',
    }),
  },
}
</script>